import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, polymorphicFactory, useProps } from '@coveord/plasma-mantine';
import { useEmptyStateContext } from './EmptyStateContext.js';
var defaultProps = {};
export var EmptyStateBody = polymorphicFactory(function(_props, ref) {
    var ctx = useEmptyStateContext();
    var _useProps = useProps('EmptyStateBody', defaultProps, _props), style = _useProps.style, className = _useProps.className, classNames = _useProps.classNames, styles = _useProps.styles, children = _useProps.children, others = _object_without_properties(_useProps, [
        "style",
        "className",
        "classNames",
        "styles",
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
        ref: ref
    }, ctx.getStyles('body', {
        classNames: classNames,
        className: className,
        styles: styles,
        style: style
    }), others), {
        children: children
    }));
});

//# sourceMappingURL=EmptyStateBody.js.map